import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { importProvidersFrom } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { I18nHelper } from '@core/i18n';

export const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http, '/i18n/', '.json');

export function provideTranslateModule() {
    return importProvidersFrom(
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: I18nHelper.DEFAULT_LANGUAGE,
        })
    );
}
